import React, { useRef, useState, useEffect } from "react";
import "./App.scss";
import QRCode from "qrcode.react";
import { post, get } from "axios";
import Popup from "./components/popup/Popup";
import { fileUploadUrl, mobileAppUrl, webSocketUrl } from "./configUrl";
import { connect } from "react-redux";
import { setSuccessPopUp, setSuccessMsg } from "./action/action";
function App(props) {
  const inputReference = useRef();
  const [fileUploadState, setFileUpload] = useState(null);
  const [responseId, setResId] = useState(null);
  const [uuId, setId] = useState(null);
  let path;
  const {
    successPopup,
    setSuccessPopUp,

    setSuccessMsg
  } = props;
  const fileUploadAction = () => {
    inputReference.current.click();
  };
  const fileUploadInputChange = (e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    setFileUpload(URL.createObjectURL(e.target.files[0]));
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    let uploadUrl = `${fileUploadUrl}/fileupload/deskop?requestId=${uuId}`;
    uploadPrescription(uploadUrl, data, config);
    e.target.value = null;
  };
  const uploadPrescription = (url, data, config) => {
    if (uuId === responseId) {
      setSuccessPopUp(true);
      setSuccessMsg(
        "Prescription already updated for request id please try new request id after refresh the app.."
      );
    } else {
      if (window.loaderShowing) {
        window.loaderShowing({ value: true, text: "Image Uploading..." });
      }
      post(url, data && data, config && config).then(
        (response) => {
          if (response.data.status === "success") {
            if (window.loaderShowing) {
              window.loaderShowing({
                value: true,
                text: "We received your prescription..."
              });
            }
          }
        },
        (error) => {
          if (window.loaderShowing) {
            window.loaderShowing({ value: false, text: "" });
          }

          setSuccessPopUp(true);
          setSuccessMsg(
            "Something went wrong, While uploading your prescription Please try again..."
          );
        }
      );
    }
  };
  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
      c
    ) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  useEffect(() => {
    setId(uuidv4());
  }, []);
  useEffect(() => {
    if (uuId !== null) {
      websocketConnection();
    }
  }, [uuId]);
  const websocketConnection = () => {
    get(`${webSocketUrl}${uuId}`)
      .then((response) => {
        let endPoint = response.data.wsUrl;
        let ws = new WebSocket(endPoint);
        ws.onopen = () =>
          console.log("********* Connected to server *********");
        ws.onmessage = (event) => {
          let data = JSON.parse(event.data);
          if (data.eventType === "fileUploaded") {
            path = data.fileUrl;
            if (window.loaderShowing) {
              window.loaderShowing({
                value: true,
                text: "Extracting  data from prescription image..."
              });
            }
          }

          if (data.eventType === "analysisBegin") {
            if (window.loaderShowing) {
              window.loaderShowing({
                value: true,
                text: "Loading prescription data..."
              });
            }
          }
          if (data.eventType === "analysisEnd") {
            setResId(data.requestId);
            if (window.loaderShowing) {
              window.loaderShowing({
                value: false,
                text: ""
              });
            }
            if (window.setPreview) {
              window.setPreview(path);
            }

            if (window.getPrescriptionData) {
              window.getPrescriptionData(
                data ? JSON.parse(data.prescription) : []
              );
            }
          }
        };
      })
      .catch((err) => {
        console.log("err::", err);
        setSuccessPopUp(true);
        setSuccessMsg(
          "Something went wrong, Prescription did not parse, Please try again!"
        );
      });
  };
  //This useEffect use as componentWillUnmount
  useEffect(() => {
    return () => {
      setFileUpload(null);
    };
  }, []);
  const clickHandler = () => {
    setSuccessPopUp(false);
  };

  return (
    <div className="container">
      {successPopup && (
        <Popup onClick={clickHandler} text={props?.successMsg} />
      )}

      <div className="section">
        <div>
          {fileUploadState != null ? (
            <img src={fileUploadState} className="preview-img" alt="preview" />
          ) : (
            "Prescription Image preview"
          )}
        </div>
        <div>
          <h3>Upload your Prescription</h3>
          <input
            type="file"
            hidden
            ref={inputReference}
            onChange={fileUploadInputChange}
          />
          <div className="btn-block">
            <button className="btn btn-success" onClick={fileUploadAction}>
              <p className="upload-btn-text">Upload</p>
              <p className="take-picture-text">Take Picture</p>
            </button>
            <div className="labelText">
              {" "}
              <p>--OR--</p>Scan QR-CODE to upload prescription in mobile
            </div>
            <div className="qr-code-img">
              <QRCode value={`${mobileAppUrl}?requestId=${uuId}`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    successPopup: state.PopUpShowSuccess,
    successMsg: state.successMsg
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopUp: (val) => dispatch(setSuccessPopUp(val)),
    setSuccessMsg: (msg) => dispatch(setSuccessMsg(msg))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
